import React from 'react'
import { Provider } from './provider';
import { Field } from './field';
import { FieldEditor } from './field-editor';
import { Menu } from './menu';

export const InlineFieldEditor = (props) => {
    return (
        <Provider options={props}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <Field />
                <FieldEditor />
                <Menu />
            </div>
        </Provider>
    );
};
